import React from "react";
import styled from "styled-components";
import { Table, Tag, Empty, Skeleton } from "antd";
import {
  UserOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  DollarOutlined,
} from "@ant-design/icons";

const ReferralInvitesTable = ({ loading = false, data = [] }) => {
  const columns = [
    {
      title: "Email/Name",
      dataIndex: "emailOrName",
      key: "emailOrName",
      render: (text) => (
        <UserInfo>
          <UserOutlined />
          <span>{text}</span>
        </UserInfo>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        const statusConfig = {
          invited: { color: "blue", icon: <UserOutlined />, text: "Invited" },
          trial: {
            color: "orange",
            icon: <ClockCircleOutlined />,
            text: "Trial",
          },
          paying: {
            color: "green",
            icon: <CheckCircleOutlined />,
            text: "Paying",
          },
        };

        const config = statusConfig[status] || statusConfig.invited;

        return (
          <Tag color={config.color} icon={config.icon}>
            {config.text}
          </Tag>
        );
      },
    },
    {
      title: "Joined",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) => new Date(date).toLocaleDateString(),
    },
  ];

  if (loading) {
    return (
      <TableContainer>
        <Skeleton active paragraph={{ rows: 4 }} />
      </TableContainer>
    );
  }

  if (!data || data.length === 0) {
    return (
      <TableContainer>
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No referrals yet"
          style={{ padding: "40px 0" }}
        >
          <EmptyDescription>
            Share your referral link to start earning rewards!
          </EmptyDescription>
        </Empty>
      </TableContainer>
    );
  }

  return (
    <TableContainer>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="emailOrName"
        pagination={false}
        size="middle"
      />
    </TableContainer>
  );
};

const TableContainer = styled.div`
  background: var(--color-background);
  border-radius: 8px;
  overflow: hidden;

  .ant-table {
    background: transparent;
  }

  .ant-table-thead > tr > th {
    background: var(--color-bg-secondary);
    border-bottom: 1px solid var(--color-border-light);
    color: var(--color-text);
    font-weight: 600;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid var(--color-border-light);
    color: var(--color-text);
  }

  .ant-table-tbody > tr:hover > td {
    background: var(--color-bg-secondary);
  }
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .anticon {
    color: var(--color-text-light);
  }
`;

const EmptyDescription = styled.div`
  color: var(--color-text-light);
  font-size: 14px;
`;

export default ReferralInvitesTable;
